import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-historial',
  templateUrl: './historial.component.html',
  styleUrls: ['./historial.component.scss']
})
export class HistorialComponent implements OnInit {
  idtitulo: string;
  historialHtml: any;

  constructor(private route: ActivatedRoute,private http:HttpClient,
    private sanitizer:DomSanitizer) { }

  ngOnInit() {
    this.idtitulo = String(this.route.snapshot.params['idtitulo']);
    console.log(this.idtitulo);
    //this.http.get('http://deva.aac.es').map((response: Response) => console.log(response) );


    this.http.get('http://deva.aac.es/seguimientotitulos/common/historialPublico.asp?idtitulo='+this.idtitulo+'&v=y72Vqy52xgqo4aBJUZXKpqbsEpkiUvnCxtr').map((html:any) => console.log(html.data));
    
    /*
    this.http.get('http://deva.aac.es/seguimientotitulos/common/historialPublico.asp?idtitulo='+this.idtitulo+'&v=y72Vqy52xgqo4aBJUZXKpqbsEpkiUvnCxtr').subscribe(res=>{
      this.historialHtml = this.sanitizer.bypassSecurityTrustHtml(res);
      console.log(res)
    })
*/

  }

}



// WEBPACK FOOTER //
// /app/src/app/modules/general/historial/historial.component.ts